import { TimePrescreeningSearchStatusResponseDtoType } from '../types/timePrescreeningApi';

import axios from '../axios';
import { V3_TIME_PRESCREENING } from '../constants';

export const searchesApi = {
  getSearchStatus: async (trialId: string): Promise<TimePrescreeningSearchStatusResponseDtoType> => {
    const { data } = await axios.get<TimePrescreeningSearchStatusResponseDtoType>(
      `${V3_TIME_PRESCREENING}/trials/${encodeURIComponent(trialId)}/search-status`,
    );

    return data;
  },
};
